<template>
  <div
    id="app"
    :class="
      $store.state.currentChild.class_genre == 'school'
        ? 'themeOne'
        : 'themeTwo'
    "
  >
    <div class="online-main">
      <template v-if="!$route.meta.keepAlive">
        <router-view v-if="$route.meta.isLogin || $route.meta.isNotFound"></router-view>
        <template v-else>
          <Header></Header>
          <router-view></router-view>
        </template>
      </template>

      <Header v-if="$route.meta.keepAlive"></Header>
      <keep-alive>
        <template v-if="$route.meta.keepAlive">
          <router-view></router-view>
        </template>
      </keep-alive>
    </div>

    <PageLoading :active="showLoading" />

    <popTips
      @handConfirm="handConfirm"
      @handleCloseTip="handleCloseTip"
      :dialogVisable="popTipsCont.dialogVisable"
      :popTipsCont="popTipsCont"
      :hideCloseBtn="hideCloseBtn"
    ></popTips>

    <!-- 背景音乐 -->
    <audio
      src="https://oss.kidcastle.cn/EAS/bgsound.mp3"
      class="media-audio"
      loop
      ref="MusicPlay"
      id="MusicPlay"
      preload="auto "
    ></audio>
  </div>
</template>

<script>
import Header from "./components/Header";
import PageLoading from "@/components/Loading";
import popTips from "@/components/popTips";

export default {
  name: "app",
  components: {
    Header,
    PageLoading,
    popTips,
  },
  data() {
    return {
      hideCloseBtn: true,
      INTERVAL_REMIND_TIME: 0,
      AUTO_LOGOUT_TIME: 0,
      timerCount: 0,
      quitTimer: null,
      popTipsCont: {
        popTipsType: '',
        dialogVisable: false,
        title: "提示",
        context: '',
        btns: [
          {
            text: this.$t("Common.confirm"),
            event: "handConfirm",
          }
        ],
      },
    };
  },
  mounted() {},
  updated() {},
  created() {
    if (this.$Tool.getStorage("languageType")) {
      window.document.title = this.$t("Common.title");
    } else {
      window.document.title = this.$t("Common.title");
    }

    if (this.$store.state.currentChild.class_genre == "school") {
      //少儿-校
    } else if (this.$store.state.currentChild.class_genre == "kid") {
      //幼儿 - 园
    }

    let token = this.$Tool.getStorage('token')
    let member_id = this.$Tool.getStorage('member_id')
    if (token && member_id) {
      this.getOneStudent().then(res => {
        if (res.status == 'success') {
          if (res.INTERVAL_REMIND_TIME) {
            this.setQuitPop()
          }
        }
        // this.popTipsCont.dialogVisable = true
        // this.quitTimer = setInterval(() => {
        //   console.log("this is quit timer");
        // }, 1000);
      })
    }
  },
  watch: {
    $route(to, from, next) {
      if (this.$Tool.getStorage("isPlay")) {
        if (this.$route.meta.hasOwnProperty("isPlayAudio")) {
          //此页面有isPlayAudio,不播放
          this.$nextTick(() => {
            document.getElementById("MusicPlay").pause();
          });
        } else {
          this.$nextTick(() => {
            document.getElementById("MusicPlay").play();
          });
        }
      } else {
        this.$nextTick(() => {
          document.getElementById("MusicPlay").pause();
        });
      }
    },
  },
  computed: {
    // isPlayAudio(){
    //   return  this.$route.meta.isPlayAudio;
    // }
    showLoading() {
      return this.$store.state.isLoading;
    }
  },
  methods: {
    setQuitPop() {
      this.quitTimer = setInterval(() => {
        ++this.timerCount

        if (this.timerCount == this.AUTO_LOGOUT_TIME) {
          clearInterval(this.quitTimer)
          this.popTipsCont.context = this.$t('Common.quitTips1')
          this.popTipsCont.popTipsType = 'quit' // 强制退出
          this.popTipsCont.dialogVisable = true
          this.quit()
        } else if (this.timerCount % this.INTERVAL_REMIND_TIME == 0) {
          clearInterval(this.quitTimer)

          this.popTipsCont.context = this.$t('Common.quitTips2')
          this.popTipsCont.popTipsType = 'quit-tips' // 提醒休息
          this.popTipsCont.dialogVisable = true
        }
        // if (this.timerCount % this.INTERVAL_REMIND_TIME == 0) {
        //   clearInterval(this.quitTimer)
        //   if (this.timerCount == this.AUTO_LOGOUT_TIME) {
        //     this.popTipsCont.context = this.$t('Common.quitTips1')
        //     this.popTipsCont.popTipsType = 'quit' // 强制退出
        //     this.popTipsCont.dialogVisable = true
        //     this.quit()
        //   } else {
        //     this.popTipsCont.context = this.$t('Common.quitTips2')
        //     this.popTipsCont.popTipsType = 'quit-tips' // 提醒休息
        //     this.popTipsCont.dialogVisable = true
        //   }
        // }
      }, 1000);
    },
    getOneStudent () {
      return new Promise(resolve => {
        this.$Http.getOneStudent({
          student_id: this.$store.state.currentChild.student_id,
          member_id: this.$store.state.member_id,
          token: this.$store.state.token
        }).then(res => {
          const { error, result } = res.data
          if (error == 0) {
            const { student_autologoutTime, student_intervalremindTime } = result.list
            this.AUTO_LOGOUT_TIME = Number(student_autologoutTime)
            this.INTERVAL_REMIND_TIME = Number(student_intervalremindTime)
            this.$Tool.setStorage('AUTO_LOGOUT_TIME', this.AUTO_LOGOUT_TIME)
            this.$Tool.setStorage('INTERVAL_REMIND_TIME', this.INTERVAL_REMIND_TIME)
          }
          resolve({
            'AUTO_LOGOUT_TIME': this.AUTO_LOGOUT_TIME,
            'INTERVAL_REMIND_TIME': this.INTERVAL_REMIND_TIME,
            'status': 'success'
          })
        })
      })
    },
    handleCloseTip() {
      this.popTipsCont.dialogVisable = false;
    },
    handConfirm() {
      if (this.popTipsCont.popTipsType == 'quit-tips') {
        this.popTipsCont.dialogVisable = false;
        this.setQuitPop()
      } else {
        this.popTipsCont.dialogVisable = false;
        window.location.href = '/login'
      }
    },
    quit(){
      this.$Tool.removeStorage("token");
      this.$Tool.removeStorage("member_id");
      this.$store.dispatch("setUserToken", "");
      this.$store.dispatch("setMemberId", "");
      this.$Tool.setStorage("isPlay", false);
      this.$store.dispatch("setbgMusic", false);
      if (!this.$Tool.getStorage("rember")) {
        this.$Tool.setStorage("psw", ""); //密码
        this.$Tool.setStorage("account", ""); //账号
      }
    }
  },
};
</script>

<style lang="less">
@import url("assets/less/common.less");
@import url("assets/less/reset.less");
@import url("assets/fonts/style.css");
</style>
